import { useRecoilCallback } from 'recoil';
import {
    type OperationPanelState,
    operationBusyState,
    operationPanelState,
} from '~/state/atoms/toolsAtoms';

type OperationPanelUpdate =
    | OperationPanelState
    | ((prev: OperationPanelState) => OperationPanelState);

/**
 * Returns a setter for the operation panel that does nothing while the open
 * operation is busy, so a user action can neither close nor replace an
 * operation that is previewing or writing. It takes a value or an updater,
 * as a Recoil setter does.
 */
export function useSetOperationPanelUnlessBusy(): (
    update: OperationPanelUpdate
) => void {
    return useRecoilCallback(
        ({ snapshot, set }) =>
            (update: OperationPanelUpdate) => {
                if (snapshot.getLoadable(operationBusyState).getValue()) {
                    return;
                }
                set(operationPanelState, update);
            },
        []
    );
}
